// extracted by mini-css-extract-plugin
export default {"title":"NitLWpw4Ll9u6M72K7jz"};